import React from 'react';
import PropTypes from 'prop-types';
import styles from './Modal.module.css';

/**
 * Modal
 * Reusable, dismissible modal with header, body, and optional footer.
 *
 * Props:
 * - open: boolean (controls visibility)
 * - onClose: () => void (called when backdrop or close button is clicked)
 * - title?: string | ReactNode
 * - actions?: ReactNode (header right-side actions)
 * - footer?: ReactNode (footer content and actions)
 * - children: ReactNode (modal body)
 */
export function Modal({ open, onClose, title, actions, footer, children }) {
  return (
    <div
      className={`${styles.backdrop} ${open ? '' : styles.hidden}`}
      role="dialog"
      aria-modal={open || undefined}
      onClick={onClose}
    >
      <div className={styles.dialog} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h5 className={styles.title}>{title}</h5>
          <div className={styles.headerActions}>
            {actions}
            <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">
              ✕
            </button>
          </div>
        </div>
        <div className={styles.body}>{children}</div>
        {footer ? <div className={styles.footer}>{footer}</div> : null}
      </div>
    </div>
  );
}

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  actions: PropTypes.node,
  footer: PropTypes.node,
  children: PropTypes.node,
};

export default Modal;
